import { InitializationSteps } from './types';
import { IPortal } from '@/types';
import { LegacyUserFlow } from './legacy-user-flow';
import { NewUserFlow } from './new-user-flow';
import { LegacyUserNoPortalFlow } from './legacy-user-no-portal-flow';
import { Button, DynamicModal } from '@fileverse/ui';

interface ModalContentProps {
  flow: 'legacy' | 'new' | null;
  portalKeys?: IPortal | null;
  identityAlreadyExists: boolean;
  onCompleteSetup: (flow?: 'legacy' | 'new') => void;
  modalStates: {
    isMigrationModalOpen: boolean;
    isGunYesPortalKeysNull: boolean;
    isInitialModalLoading: boolean;
  };
  setModalStates: (modalStates: {
    isMigrationModalOpen: boolean;
    isGunYesPortalKeysNull: boolean;
    isInitialModalLoading: boolean;
  }) => void;
}

export const ModalContent = ({
  flow,
  portalKeys,
  identityAlreadyExists,
  onCompleteSetup,
  modalStates,
  setModalStates,
}: ModalContentProps) => {
  switch (flow) {
    case 'legacy':
      if (portalKeys) {
        return (
          <>
            <DynamicModal
              open={modalStates.isMigrationModalOpen}
              onOpenChange={(open) =>
                setModalStates({
                  ...modalStates,
                  isMigrationModalOpen: open,
                })
              }
              className="md:!max-w-[23rem] !pb-0 !rounded-lg "
              contentClassName="!py-6"
              content={
                <div className="flex flex-col gap-4 justify-center items-center px-4 text-center">
                  <div className="flex items-center justify-center px-[9px] py-[5px] rounded color-bg-secondary">
                    <span className="text-heading-lg">👩‍🏭</span>
                  </div>
                  <h3 className="text-heading-sm">Upgrading your account</h3>
                  <p className="text-body-sm color-text-secondary">
                    Your dDocs is getting a super upgrade for better performance
                    and reliability. This should take no more than 40 seconds.
                  </p>

                  <div className="flex justify-center items-center gap-2 w-full">
                    <Button
                      className="w-full md:w-auto"
                      variant="secondary"
                      onClick={() => {
                        window.open('/infra-upgrade', '_blank');
                      }}
                    >
                      Learn more
                    </Button>
                    <Button
                      className="w-full md:w-auto"
                      variant="default"
                      onClick={() => {
                        setModalStates({
                          ...modalStates,
                          isMigrationModalOpen: false,
                        });
                      }}
                    >
                      Upgrade account
                    </Button>
                  </div>
                </div>
              }
            />
            <div className={modalStates.isMigrationModalOpen ? 'hidden' : ''}>
              <LegacyUserFlow
                startFrom={
                  identityAlreadyExists
                    ? InitializationSteps.CHECK_AND_TRANSFER_OWNERSHIP
                    : InitializationSteps.SETUP_NEW_IDENTITY_MODULE
                }
                portalKeys={portalKeys}
                onCompleteSetup={onCompleteSetup}
              />
            </div>
          </>
        );
      } else {
        return (
          <LegacyUserNoPortalFlow
            startFrom={
              identityAlreadyExists
                ? InitializationSteps.DEPLOY_PORTAL
                : InitializationSteps.SETUP_NEW_IDENTITY_MODULE
            }
            onCompleteSetup={onCompleteSetup}
          />
        );
      }

    case 'new':
      return (
        <NewUserFlow
          startFrom={
            identityAlreadyExists
              ? InitializationSteps.DEPLOY_PORTAL
              : InitializationSteps.SETUP_NEW_IDENTITY_MODULE
          }
          onCompleteSetup={onCompleteSetup}
        />
      );

    default:
      return null;
  }
};
